import React from 'react';
import {connect} from 'react-redux';
import Text from '../containers/Text';

const Message = ({message}) => {
  if (!message) {
    return null;
  }

  return <div className='alert alert-danger m-md'>
    <Text id={message} />
  </div>;
};

//
// CONTAINER
//
const mapStateToProps = ({message}) => ({
  message
});

export default connect(mapStateToProps)(Message);
